import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", { fill: "currentColor" }, [
      createElementVNode("path", { d: "m10.46 18.37-2.74 2.74a2.86 2.86 0 0 1-3.94 0l-.89-.89a2.77 2.77 0 0 1-.82-2 2.74 2.74 0 0 1 .82-2l5.8-5.81a2.8 2.8 0 0 1 3.94 0l.89.9A1 1 0 1 0 14.94 10l-.89-.89a4.79 4.79 0 0 0-6.77 0l-5.81 5.8a4.79 4.79 0 0 0 0 6.77l.89.89a4.78 4.78 0 0 0 6.78 0l2.73-2.73a1 1 0 0 0 0-1.42 1 1 0 0 0-1.41-.05" }),
      createElementVNode("path", { d: "m22.53 2.36-.9-.89a4.8 4.8 0 0 0-6.77 0L12 4.38a1 1 0 1 0 1.41 1.41l2.91-2.9a2.79 2.79 0 0 1 3.94 0l.89.9a2.74 2.74 0 0 1 .82 2 2.77 2.77 0 0 1-.82 2l-5.8 5.8a2.77 2.77 0 0 1-2 .82 2.75 2.75 0 0 1-2-.82A1 1 0 0 0 10 14.93a4.76 4.76 0 0 0 3.39 1.41 4.75 4.75 0 0 0 3.38-1.4l5.81-5.81a4.79 4.79 0 0 0 0-6.77Z" })
    ], -1)
  ]));
}
const EditorLink = { render };
export {
  EditorLink as default,
  render
};
//# sourceMappingURL=EditorLink.svg.js.map
